"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrontmatterParseError = void 0;
exports.loadDoc = loadDoc;
const gray_matter_1 = __importDefault(require("gray-matter"));
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../core/dist");
class FrontmatterParseError extends Error {
    constructor(filePath, rawFrontmatter, message) {
        super(`Invalid frontmatter in ${filePath}: ${message}`);
        this.filePath = filePath;
        this.rawFrontmatter = rawFrontmatter;
        this.name = 'FrontmatterParseError';
    }
}
exports.FrontmatterParseError = FrontmatterParseError;
async function loadDoc(filePath) {
    const content = await fs.readFile(filePath, 'utf8');
    let parsed;
    try {
        parsed = (0, gray_matter_1.default)(content);
    }
    catch (e) {
        throw new FrontmatterParseError(filePath, '', `YAML syntax error: ${e.message}`);
    }
    // Validate required fields
    const requiredFields = ['type', 'id', 'status', 'created', 'version'];
    for (const field of requiredFields) {
        if (parsed.data[field] === undefined) {
            throw new FrontmatterParseError(filePath, JSON.stringify(parsed.data), `Missing required field: ${field}`);
        }
    }
    const doc = {
        ...parsed.data,
        content: parsed.content,
        _path: filePath,
    };
    // Coerce date fields to canonical YYYY-MM-DD strings. gray-matter parses an
    // unquoted `created: 2026-06-09` as a JS Date; without this the in-memory domain
    // would carry Date objects that re-serialize as full-ISO — the drift that mixed
    // formats in the first place. Now the whole domain sees canonical date strings.
    if (doc.created !== undefined)
        doc.created = (0, dist_1.toCanonical)(doc.created);
    if (doc.updated !== undefined)
        doc.updated = (0, dist_1.toCanonical)(doc.updated);
    // Plan steps: frontmatter is the source of truth. If a structured `steps` block is
    // present, use it (the body table is a generated view, ignored on load). Otherwise
    // fall back to parsing the body table — a READ-ONLY legacy bridge for not-yet-migrated
    // plans. `_stepsFromFrontmatter` records which path was taken so the saver only
    // re-persists frontmatter steps for already-migrated docs (no implicit migration on save).
    if (doc.type === 'plan') {
        if (Array.isArray(parsed.data.steps)) {
            doc.steps = (0, dist_1.parseFrontmatterSteps)(parsed.data.steps);
            doc._stepsFromFrontmatter = true;
        }
        else if (parsed.content) {
            doc.steps = (0, dist_1.parseStepsTable)(parsed.content);
            doc._stepsFromFrontmatter = false;
        }
        else {
            doc.steps = [];
            doc._stepsFromFrontmatter = false;
        }
    }
    return doc;
}
